<template>
  <div class="content">

    <div style="background: white;border-radius: 16px;padding: 30px 16px 36px 16px">
      <p class="title">
        调研问卷调研活动说明：
      </p>
      <p class="text-content" style="margin-top: 11px">
        本次调研不是试图销售任何产品或者服务，请放心填写，根据相关法律法规对于个人信息权益的保护，您的回答绝对保密，我们不会将您的信息泄露给任何第三方。
      </p>
    </div>

    <van-checkbox v-model="checked" shape="square" style="margin-top: 16px">我已经阅读并理解同意</van-checkbox>

    <div style="width: 100%;text-align: center;margin-top: 30px; padding-bottom: 30px">
      <van-button color="linear-gradient(to right, #7441a8, #70429f)" @click="goSurvey">进入问卷</van-button>
    </div>
  </div>
</template>

<script>
  import {Toast} from "vant";
  import untils from "@/until/until";

  export default {
    name: "guide",
    data() {
      return {
        checked: false,
        price: 0,
        formData: {},
        deviceInfo: {}
      }
    },
    created() {
      if (this.$route.query.skip){
        this.navigateToSurvey()
      }else {
        this.submitEvent("survey_guide", (success, res)=>{

        })
      }
    },
    mounted() {
      // if (!localStorage.sessionKey && untils.isWechat()) {
      //   const res = await wxLogin.getWechatAppId()
      //   await wxLogin.wxLogin(window.location.href, res.data.appId)
      // } else {
      //   let UserInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
      //   if (!UserInfo.phone || UserInfo.phone === null || UserInfo.phone === '') {
      //     if (untils.isWechat()) {
      //       const res = await wxLogin.getWechatAppId()
      //       await wxLogin.wxLogin(window.location.href, res.data.appId)
      //     }
      //   }
      // }

      this.getActivity(this.$route.query.id)
    },
    methods: {
      submitEvent(event, callback){
        let UserInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
        this.$api.my.submitEvent({
          "event": event,
          "activityId": this.$route.query.id,
          "userId": UserInfo ? UserInfo.id : "",
          "nickname": UserInfo ? UserInfo.nickName : ""
        }, (success, res)=>{
          callback(success, res)
        })
      },
      //获取活动详情
      getActivity(id) {
        this.price = this.$route.query.num
      },
      goSurvey(){
        if (!this.checked){
          Toast("请阅读并同意以上内容")
          return
        }
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        });

        this.submitEvent("survey_start", (success, res)=>{
          // this.$toast.clear()

          this.navigateToSurvey()
        })
      },
      navigateToSurvey() {
        let UserInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
        // 使用当前页面协议构建URL，生产环境为HTTPS自动保证安全，开发环境兼容HTTP
        let url = location.protocol + '//' + location.host + "/prod-api/survey/detail/" + this.$route.query.id;
        if (UserInfo && UserInfo.id) {
          url = url + "?extId=" + UserInfo.id
        }
        // 统一使用 location.href 跳转，避免 window.open 被浏览器拦截
        // 若当前在 iframe 内，则操作顶层窗口跳转；跨域场景下加 try-catch 容错
        try {
          let targetWindow = (window.top !== window.self) ? window.top : window
          targetWindow.location.href = url
        } catch (e) {
          // 跨域 iframe 中访问 window.top 可能抛出 SecurityError，回退到当前窗口跳转
          window.location.href = url
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .content{
    padding: 30px;
    background: #F6F7F9;
    height: 100vh;
    //color: #70429f;

    .title {
      font-size: 32px;
      font-weight: bold;
      color: black;
    }

    .text-content{
      font-size: 28px;
      color: #333333;
    }

    .margin-top-30{
      margin-top: 30px;
    }

    .text-red{
      font-size: 32px;
      color: red;
      font-weight: 500;
    }

    /deep/ .van-button{
      border-radius: 6px;
      font-weight: bold;
      width: 260px;
    }

    /deep/ .van-checkbox__label{
      font-size: 26px;
    }

    /deep/ .van-checkbox__icon--checked .van-icon{
      background-color: #7441a8;
      border-color: #7441a8;
    }
  }

</style>